import { render } from "./Page-entry.vue?vue&type=template&id=f9c96c12&scoped=true&lang=html"
import script from "./Page-entry.vue?vue&type=script&lang=js"
export * from "./Page-entry.vue?vue&type=script&lang=js"

import "./Page-entry.vue?vue&type=style&index=0&id=f9c96c12&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c96c12"]])

export default __exports__